// src/components/Sidebar.jsx
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
    AiOutlineDashboard,
    AiOutlineShoppingCart,
    AiOutlineTags,
    AiOutlineUser,
    AiOutlineUnorderedList,
    AiOutlineBarChart,
} from 'react-icons/ai';
import { clearAuthSession, isSuperAdmin } from '../utils/authSession';
import './sidebar.css';
import '../pages/super/superPanel.css';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { FaCrown } from 'react-icons/fa';
import { AiOutlineShop, AiOutlineSafetyCertificate, AiOutlineNotification, AiOutlineCar } from 'react-icons/ai';

const items = [
    { name: 'Dashboard', to: '/dashboard', icon: <AiOutlineDashboard /> }, // Updated to match App.js route
    { name: 'Analytics', to: '/analytics', icon: <AiOutlineBarChart /> },
  { name: 'Website Banner', to: '/website-banner', icon: <AiOutlineNotification /> },
  { name: 'Delivery Settings', to: '/delivery-settings', icon: <AiOutlineCar /> },
    {
        name: 'Customer',
        to:'/customer/list',
        icon: <AiOutlineUser />,
        
    },

    {
        name: 'Deals',
        icon: <AiOutlineTags />,
        subItems: [
            { name: 'Deal List', to: '/deals/list' },
            { name: 'Create Deal', to: '/deals/add' },
        ],
    },
    { name: 'Category', to: '/category', icon: <AiOutlineTags /> }, // <-- Yahan change kiya: Ab direct link hai
    {
        name: 'Products',
        icon: <AiOutlineShoppingCart />,
        subItems: [

            { name: 'Product List', to: '/products/list' },
            { name: 'Product Grid', to: '/products/grid' },
            { name: 'Add Product', to: '/products/add' },
        ],
    },


    {
        name: 'Orders',
        to: '/orders/list',
        icon: <AiOutlineUnorderedList />,
    },
    // { name: 'Brand', to: '/brand', icon: <AiOutlineShop /> },
    {
        name: 'Affiliates',
        icon: <AiOutlineTags />,
        subItems: [
            { name: 'Affiliate List', to: '/affiliates/list' },
            { name: 'Add Affiliate', to: '/affiliates/add' },
        ],
    },
    { name: 'Profile', to: '/profile', icon: <AiOutlineUser /> },
    // { name: 'Online Store', to: '/online-store', icon: <AiOutlineShop /> },

    {
        name: 'Inventory',
        icon: <AiOutlineUnorderedList />,
        subItems: [
            { name: 'Warehouse', to: '/inventory/list' },
            { name: 'Received Order', to: '/inventory/received-order' },
            { name: 'Return Items', to: '/inventory/return-items' },
            { name: 'All Purchase Items', to: '/inventory/all-purchase-items' },
        ],
    },
  { name: 'Invoice', to: '/invoice', icon: <AiOutlineShoppingCart /> },

];

const superPanelItems = [
  { name: 'Admin Users', to: '/super/admins', icon: <AiOutlineSafetyCertificate /> },
  { name: 'Shop Accounts', to: '/super/shops', icon: <AiOutlineShop /> },
  { name: 'Top Bar Headings', to: '/super/announcements', icon: <AiOutlineNotification /> },
];

export default function Sidebar() {
    const [openDropdown, setOpenDropdown] = useState(null);
    const showSuperPanel = isSuperAdmin();

    const handleDropdownToggle = (name) => {
        setOpenDropdown(openDropdown === name ? null : name);
    };

    const handleLogoutAndRedirect = () => {
        clearAuthSession({ keepRememberedEmail: true });
        window.location.href = '/login';
    };


    return (
        <nav className="sidebar">
            <div className="sidebar-header">
                <img src={require('../assets/images/Al-burak-logo.png')} alt='' />
            </div>
            <ul>
                {(showSuperPanel ? items.filter((item) => item.name !== 'Invoice') : items).map((item) => (
                    <li key={item.name}>
                        {item.subItems ? (
                            <>
                                <div
                                    className={`sidebar-item ${openDropdown === item.name ? 'active-dropdown' : ''}`}
                                    onClick={() => handleDropdownToggle(item.name)}
                                >
                                    <span className="icon">{item.icon}</span>
                                    <span className="label">{item.name}</span>
                                    <span className="dropdown-indicator">
                                        {openDropdown === item.name ? <IoIosArrowDown /> : <IoIosArrowUp />}
                                    </span>
                                </div>
                                {openDropdown === item.name && (
                                    <ul className="dropdown-menu">
                                        {item.subItems.map((subItem) => (
                                            <li key={subItem.name}>
                                                <NavLink
                                                    to={subItem.to}
                                                    className={({ isActive }) => isActive ? 'active-sub-item' : ''}
                                                >
                                                    {subItem.name}
                                                </NavLink>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </>
                        ) : (
                            <NavLink
                                to={item.to}
                                className={({ isActive }) => isActive ? 'active' : ''}
                            >
                                <span className="icon">{item.icon}</span>
                                <span className="label">{item.name}</span>
                            </NavLink>
                        )}
                    </li>
                ))}
                {showSuperPanel && (
                    <li>
                        <div className="sidebar-super-block">
                            <div className="sidebar-super-header">
                                <FaCrown className="sidebar-super-crown" />
                                <span className="sidebar-super-title">Super Panel</span>
                            </div>
                            {superPanelItems.map((item) => (
                                <NavLink
                                    key={item.name}
                                    to={item.to}
                                    end={item.to === '/super/admins'}
                                    className={({ isActive }) =>
                                      `sidebar-super-link${isActive ? ' active' : ''}`
                                    }
                                >
                                    <span className="icon">{item.icon}</span>
                                    <span className="label">{item.name}</span>
                                </NavLink>
                            ))}
                        </div>
                    </li>
                )}
            </ul>
            <button className="logout" onClick={handleLogoutAndRedirect}>
                Logout
            </button>
        </nav>
    );
}